import { render, staticRenderFns } from "./QTooltipDetails.vue?vue&type=template&id=d67d4a20&scoped=true&"
import script from "./QTooltipDetails.vue?vue&type=script&lang=js&"
export * from "./QTooltipDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67d4a20",
  null
  
)

export default component.exports